export function wasResolved<T>(promise: Promise<T>) {
  return promise.then(() => true).catch(() => false)
}
